import { Tooltip } from "@material-ui/core";
import { LoadingButton } from "@material-ui/lab";
import flashFill from "@iconify/icons-eva/flash-fill";
import Iconify from "src/components/iconify";
import PropTypes from "prop-types";
import { propuestasApi } from "src/services/propuestasApi";
import { useSnackbar } from "src/components/snackbar";

const GenerarProximosPasosButton = ({
  items,
  solicitanteNombre,
  sucursal,
  proximosPasos,
  onGenerated,
  disabled,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [generarProximosPasos, { isLoading }] =
    propuestasApi.useGenerarProximosPasosMutation();

  const puedeGenerar = Array.isArray(items) && items.length > 0;

  const handleClick = async () => {
    if (!puedeGenerar) return;
    try {
      const resultado = await generarProximosPasos({
        items: items.map((it) => ({
          tipoItem: it.tipoItem,
          nombreServicio: it.nombreServicio || it.faseTitulo || "",
          tipoFrecuencia: it.tipoFrecuencia || null,
        })),
        ...(solicitanteNombre ? { solicitanteNombre } : {}),
        ...(sucursal ? { sucursal } : {}),
        ...(proximosPasos ? { proximosPasos } : {}),
      }).unwrap();
      onGenerated(resultado.proximosPasos);
    } catch {
      enqueueSnackbar(
        "No se pudo generar los próximos pasos. Intenta nuevamente.",
        {
          variant: "error",
          anchorOrigin: { vertical: "bottom", horizontal: "center" },
        },
      );
    }
  };

  return (
    <Tooltip
      title={
        puedeGenerar
          ? "Generar próximos pasos con IA"
          : "Agrega al menos un servicio antes de generar los próximos pasos"
      }
    >
      <span>
        <LoadingButton
          size="small"
          variant="outlined"
          color="secondary"
          loading={isLoading}
          disabled={disabled || !puedeGenerar}
          onClick={handleClick}
          startIcon={<Iconify icon={flashFill} width={16} height={16} />}
        >
          Generar con IA
        </LoadingButton>
      </span>
    </Tooltip>
  );
};

GenerarProximosPasosButton.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      tipoItem: PropTypes.string,
      nombreServicio: PropTypes.string,
      tipoFrecuencia: PropTypes.string,
    }),
  ),
  solicitanteNombre: PropTypes.string,
  sucursal: PropTypes.string,
  proximosPasos: PropTypes.string,
  onGenerated: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

GenerarProximosPasosButton.defaultProps = {
  items: [],
  solicitanteNombre: undefined,
  sucursal: undefined,
  proximosPasos: undefined,
  disabled: false,
};

export default GenerarProximosPasosButton;
